module.exports = __webpack_public_path__ + "static/media/vip.5c81c145.png";